"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.l = void 0;
var assign_1 = __importDefault(require("lodash/assign"));
var capitalize_1 = __importDefault(require("lodash/capitalize"));
var clone_1 = __importDefault(require("lodash/clone"));
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var debounce_1 = __importDefault(require("lodash/debounce"));
var defaultTo_1 = __importDefault(require("lodash/defaultTo"));
var filter_1 = __importDefault(require("lodash/filter"));
var find_1 = __importDefault(require("lodash/find"));
var findIndex_1 = __importDefault(require("lodash/findIndex"));
var forEach_1 = __importDefault(require("lodash/forEach"));
var includes_1 = __importDefault(require("lodash/includes"));
var indexOf_1 = __importDefault(require("lodash/indexOf"));
var isArray_1 = __importDefault(require("lodash/isArray"));
var isBoolean_1 = __importDefault(require("lodash/isBoolean"));
var isFunction_1 = __importDefault(require("lodash/isFunction"));
var isNaN_1 = __importDefault(require("lodash/isNaN"));
var isNil_1 = __importDefault(require("lodash/isNil"));
var isNumber_1 = __importDefault(require("lodash/isNumber"));
var isObject_1 = __importDefault(require("lodash/isObject"));
var isString_1 = __importDefault(require("lodash/isString"));
var join_1 = __importDefault(require("lodash/join"));
var map_1 = __importDefault(require("lodash/map"));
var max_1 = __importDefault(require("lodash/max"));
var maxBy_1 = __importDefault(require("lodash/maxBy"));
var merge_1 = __importDefault(require("lodash/merge"));
var min_1 = __importDefault(require("lodash/min"));
var minBy_1 = __importDefault(require("lodash/minBy"));
var parseInt_1 = __importDefault(require("lodash/parseInt"));
var pull_1 = __importDefault(require("lodash/pull"));
var random_1 = __importDefault(require("lodash/random"));
var range_1 = __importDefault(require("lodash/range"));
var remove_1 = __importDefault(require("lodash/remove"));
var replace_1 = __importDefault(require("lodash/replace"));
var reverse_1 = __importDefault(require("lodash/reverse"));
var sample_1 = __importDefault(require("lodash/sample"));
var some_1 = __importDefault(require("lodash/some"));
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var split_1 = __importDefault(require("lodash/split"));
var take_1 = __importDefault(require("lodash/take"));
var times_1 = __importDefault(require("lodash/times"));
var toArray_1 = __importDefault(require("lodash/toArray"));
var union_1 = __importDefault(require("lodash/union"));
var uniq_1 = __importDefault(require("lodash/uniq"));
var shuffle_1 = __importDefault(require("lodash/shuffle"));
// import merge from 'lodash/merge'
var lo = {
    assign: assign_1.default,
    capitalize: capitalize_1.default,
    clone: clone_1.default,
    cloneDeep: cloneDeep_1.default,
    debounce: debounce_1.default,
    defaultTo: defaultTo_1.default,
    filter: filter_1.default,
    find: find_1.default,
    findIndex: findIndex_1.default,
    forEach: forEach_1.default,
    includes: includes_1.default,
    indexOf: indexOf_1.default,
    isArray: isArray_1.default,
    isBoolean: isBoolean_1.default,
    isFunction: isFunction_1.default,
    isNaN: isNaN_1.default,
    isNil: isNil_1.default,
    isNumber: isNumber_1.default,
    isObject: isObject_1.default,
    isString: isString_1.default,
    join: join_1.default,
    map: map_1.default,
    max: max_1.default,
    maxBy: maxBy_1.default,
    merge: merge_1.default,
    min: min_1.default,
    minBy: minBy_1.default,
    parseInt: parseInt_1.default,
    pull: pull_1.default,
    random: random_1.default,
    range: range_1.default,
    remove: remove_1.default,
    replace: replace_1.default,
    reverse: reverse_1.default,
    sample: sample_1.default,
    some: some_1.default,
    sortBy: sortBy_1.default,
    split: split_1.default,
    take: take_1.default,
    times: times_1.default,
    toArray: toArray_1.default,
    union: union_1.default,
    uniq: uniq_1.default,
    shuffle: shuffle_1.default,
    //merge,
};
var l = lo;
exports.l = l;
// Hack to use external variable if available
if (typeof _ !== 'undefined') {
    exports.l = l = _;
}
// export const lodash = _
